/**
 * Convierte lo que devuelve ECharts dataZoom sobre un eje X categórico (tiempo.toFixed(1))
 * al índice dentro de `sistema_de_pesos_y_tiempos`.
 */
export function valorDataZoomAIndice(sistema, raw) {
    const n = sistema?.length ?? 0;
    if (!n) return 0;
    if (raw == null || raw === "") return 0;

    if (typeof raw === "number" && Number.isFinite(raw)) {
        const ri = Math.round(raw);
        if (ri >= 0 && ri < n && Math.abs(raw - ri) < 1e-9) {
            return ri;
        }
        return indiceMasCercanoPorTiempo(sistema, raw);
    }

    const str = String(raw).trim().replace(",", ".");
    const porCategoria = sistema.findIndex((s) => s.tiempo.toFixed(1) === str);
    if (porCategoria >= 0) return porCategoria;

    const tNum = Number(str);
    if (Number.isFinite(tNum)) return indiceMasCercanoPorTiempo(sistema, tNum);

    return 0;
}

function indiceMasCercanoPorTiempo(sistema, t) {
    let best = 0;
    let bestD = Infinity;
    for (let i = 0; i < sistema.length; i++) {
        const d = Math.abs(Number(sistema[i].tiempo) - t);
        if (d < bestD) {
            bestD = d;
            best = i;
        }
    }
    return best;
}

/**
 * Rango de índices del array de muestras visible según dataZoom (categoría o %).
 * @returns {{ inicioIdx: number, finExclusivo: number, finInclusivo: number }}
 */
export function dataZoomARangoSlice(sistema, dz) {
    const n = sistema?.length ?? 0;
    if (!n) return { inicioIdx: 0, finExclusivo: 0, finInclusivo: -1 };

    const opt = dz && typeof dz === "object" ? dz : {};

    if (opt.startValue != null || opt.endValue != null) {
        let a = valorDataZoomAIndice(sistema, opt.startValue != null ? opt.startValue : 0);
        let b = valorDataZoomAIndice(sistema, opt.endValue != null ? opt.endValue : n - 1);
        if (a > b) [a, b] = [b, a];
        const finInclusivo = Math.min(n - 1, b);
        return {
            inicioIdx: Math.max(0, a),
            finExclusivo: Math.min(n, finInclusivo + 1),
            finInclusivo,
        };
    }

    if (typeof opt.start === "number" && typeof opt.end === "number") {
        const span = Math.max(0, n - 1);
        const i0 = Math.round((span * opt.start) / 100);
        const i1 = Math.round((span * opt.end) / 100);
        const lo = Math.max(0, Math.min(i0, i1));
        const hi = Math.min(n - 1, Math.max(i0, i1));
        return { inicioIdx: lo, finExclusivo: hi + 1, finInclusivo: hi };
    }

    return { inicioIdx: 0, finExclusivo: n, finInclusivo: n - 1 };
}

/** Elige el primer dataZoom del getOption() que tenga rango útil. */
export function elegirOpcionDataZoom(opcionCompleta) {
    const lista = opcionCompleta?.dataZoom;
    if (!Array.isArray(lista) || !lista.length) return {};
    const conValores = lista.find(
        (d) =>
            d &&
            (d.startValue != null ||
                d.endValue != null ||
                typeof d.start === "number" ||
                typeof d.end === "number")
    );
    return conValores || lista[0] || {};
}
